import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiButton = {
    styleOverrides: {
        root: { borderRadius: '10px', textTransform: 'none' },
        sizeSmall: { padding: '6px 16px' },
        sizeMedium: { padding: '8px 20px' },
        sizeLarge: { padding: '11px 24px' },

        containedSizeSmall: { padding: '6px 16px' },
        containedSizeMedium: { padding: '8px 20px' },
        containedSizeLarge: { padding: '11px 24px' },

        outlinedSizeSmall: { padding: '4px 6px' },
        outlinedSizeMedium: { padding: '7px 18px' },
        outlinedSizeLarge: { padding: '8px 20px' },
    },
} satisfies Components<Theme>['MuiButton'];
